(function () {
  if (window.ncCollectionMobileReady) return;
  window.ncCollectionMobileReady = true;

  /* ---------- Galería con flechas ---------- */
  function updateArrows(track) {
    var media = track.closest('[data-nc-start]');
    if (!media) return;
    var max = track.scrollWidth - track.clientWidth - 2;
    media.setAttribute('data-nc-start', track.scrollLeft <= 2 ? 'true' : 'false');
    media.setAttribute('data-nc-end', track.scrollLeft >= max ? 'true' : 'false');
  }

  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.hasAttribute('data-nc-track')) updateArrows(t);
  }, true);

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-nc-arrow]');
    if (!arrow) return;
    e.preventDefault();
    e.stopPropagation();
    var media = arrow.closest('[data-nc-start]');
    var track = media && media.querySelector('[data-nc-track]');
    if (!track) return;
    track.scrollBy({ left: Number(arrow.getAttribute('data-nc-arrow')) * track.clientWidth, behavior: 'smooth' });
  });

  /* ---------- Panel de tallas ---------- */
  var sheet, panel, list, titleEl, priceEl, msgEl, linkEl, opener, closeTimer;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function build() {
    sheet = el('div', 'nc-sheet');
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="nc-sheet__backdrop" data-nc-sheet-close></div>' +
      '<div class="nc-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="nc-sheet-title" tabindex="-1">' +
      '<div class="nc-sheet__head"><p class="nc-sheet__title" id="nc-sheet-title"><span data-t></span><span class="nc-sheet__price" data-p></span></p>' +
      '<button type="button" class="nc-sheet__close" data-nc-sheet-close aria-label="Cerrar">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg></button></div>' +
      '<p class="nc-sheet__hint">Elige tu talla y la añadimos a tu cesta</p>' +
      '<ul class="nc-sheet__list" role="list"></ul>' +
      '<p class="nc-sheet__msg" aria-live="polite"></p>' +
      '<a class="nc-sheet__link" href="#">Ver todos los detalles</a>' +
      '</div>';
    document.body.appendChild(sheet);
    panel = sheet.querySelector('.nc-sheet__panel');
    list = sheet.querySelector('.nc-sheet__list');
    titleEl = sheet.querySelector('[data-t]');
    priceEl = sheet.querySelector('[data-p]');
    msgEl = sheet.querySelector('.nc-sheet__msg');
    linkEl = sheet.querySelector('.nc-sheet__link');

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-nc-sheet-close]')) { close(); return; }
      var b = e.target.closest('[data-nc-size]');
      if (b && !b.disabled) add(b);
    });
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = panel.querySelectorAll('button:not([disabled]), a[href]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function open(btn) {
    var card = btn.closest('.m-product-card') || btn.parentNode;
    var dataEl = card.querySelector('[data-nc-sizes-data]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }
    if (!sheet) build();
    clearTimeout(closeTimer);
    opener = btn;
    titleEl.textContent = data.title;
    priceEl.textContent = data.price || '';
    linkEl.href = data.url;
    msgEl.textContent = '';
    list.innerHTML = '';
    (data.variants || []).forEach(function (v) {
      var li = el('li');
      var b = el('button', 'nc-sheet__size');
      var label = v.label === 'Default Title' ? 'Talla única' : v.label;
      b.type = 'button';
      b.setAttribute('data-nc-size', v.id);
      b.appendChild(el('span', 'nc-sheet__label', label));
      if (!v.available) {
        b.disabled = true;
        b.appendChild(el('small', '', 'Agotada'));
        b.setAttribute('aria-label', label + ', agotada');
      } else {
        b.setAttribute('aria-label', 'Añadir talla ' + label + ' a la cesta');
      }
      li.appendChild(b);
      list.appendChild(li);
    });
    sheet.hidden = false;
    document.documentElement.classList.add('nc-sheet-open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        sheet.classList.add('is-open');
        var first = list.querySelector('button:not([disabled])');
        (first || panel).focus({ preventScroll: true });
      });
    });
  }

  function close(keepFocus) {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('nc-sheet-open');
    closeTimer = setTimeout(function () { sheet.hidden = true; }, 260);
    if (!keepFocus && opener) opener.focus({ preventScroll: true });
  }

  function getSections() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
    );
    return sections;
  }

  function add(b) {
    if (list.querySelector('.is-loading')) return;
    var labelEl = b.querySelector('.nc-sheet__label');
    var label = labelEl.textContent;
    b.classList.add('is-loading');
    labelEl.textContent = 'Añadiendo…';
    msgEl.textContent = '';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(b.getAttribute('data-nc-size')), quantity: 1, sections: getSections(), sections_url: window.location.pathname })
    })
      .then(function (res) { return res.json().then(function (d) { return { ok: res.ok, data: d }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) throw new Error((r.data && r.data.description) || 'error');
        b.classList.remove('is-loading');
        labelEl.textContent = label;
        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents && r.data.sections) {
          window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: r.data });
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        }
        var drawer = document.querySelector('m-cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          close(true);
          setTimeout(function () { drawer.open(); }, 280);
        } else {
          msgEl.textContent = 'Talla ' + label + ' añadida a tu cesta';
          setTimeout(function () { close(); }, 1600);
        }
      })
      .catch(function (err) {
        b.classList.remove('is-loading');
        labelEl.textContent = label;
        var m = err && err.message && err.message !== 'error' ? err.message : 'No hemos podido añadirla. Inténtalo de nuevo, por favor.';
        msgEl.textContent = m;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nc-sizes-open]');
    if (!btn) return;
    e.preventDefault();
    open(btn);
  });
})();
